<template>
  <v-data-table
    v-model="localSelected"
    :search="search"
    :headers="headers"
    :items="items"
    :items-per-page="-1"
    :item-class="getRowClass"
    loading-text="Cargando... Por favor espere"
    show-select
    dense
    item-key="number"
    class="main-table"
    @input="$emit('update:selected', $event)"
  >
    <template #[`item.number`]="{ item }">
      {{ item.number }}
      <special-order-type-icon :order="item.auart" />
    </template>

    <template #[`item.orderName`]="{ item }">
      <div class="col-fixed" style="--col-width: 50px">
        {{ item.orderName }}
      </div>
    </template>

    <template #[`item.amount`]="{ item }">
      {{ formatNumber(item.amount, '$') }}
    </template>

    <template #[`item.vbelnnc`]="{ item }">
      <div class="col-fixed" style="--col-width: 83px">
        {{ item.vbelnnc }}
      </div>
    </template>

    <template #[`item.status`]="{ item }">
      <div class="col-fixed" style="--col-width: 20px">
        <special-order-type-icon :order="item.status" />
      </div>
    </template>

    <template #[`item.dmbtrnc`]="{ item }">
      {{ formatNumber(item.dmbtrnc, '$') }}
    </template>

    <template #[`item.dmbtrto`]="{ item }">
      {{ formatNumber(item.dmbtrto, '$') }}
    </template>

    <template #[`item.dmbtrdz`]="{ item }">
      {{ formatNumber(item.dmbtrdz, '$') }}
    </template>

    <template #[`item.impfacnet`]="{ item }">
      {{ formatNumber(item.impfacnet, '$') }}
    </template>

    <template #[`item.difbudat`]="{ item }">
      {{ formatNumber(item.difbudat, '$') }}
    </template>

    <template #[`item.difbudatp`]="{ item }">
      {{ formatNumber(item.difbudatp, '%') }}
    </template>
  </v-data-table>
</template>

<script>
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'AccountMovementsTable',

    components: {
      SpecialOrderTypeIcon,
    },
    mixins: [numbersFormats],

    props: {
      value: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        required: true,
      },
      search: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        headers: [
          { text: 'Factura', value: 'number', visible: true },
          {
            text: 'Orden de Compra',
            value: 'orderName',
            visible: true,
          },
          { text: 'Fecha Entrega', value: 'date', visible: true },
          { text: 'Fecha Vencimiento', value: 'expiration', visible: true },
          {
            text: 'Días Venc.',
            align: 'center',
            value: 'days',
            visible: true,
          },
          { text: 'Estatus', value: 'status', visible: true },
          {
            text: 'Importe Factura',
            value: 'amount',
            cellClass: 'linea-vertical-body',
            visible: true,
          },
          {
            text: 'Nota de Crédito',
            align: 'center',
            value: 'vbelnnc',
            visible: true,
          },
          {
            text: 'Importe Nota de Crédito',
            value: 'dmbtrnc',
            cellClass: 'linea-vertical-body',
            visible: true,
          },
          {
            text: 'Pago',
            align: 'center',
            value: 'belnrdz',
            visible: true,
          },
          {
            text: 'Importe Pago',
            align: 'center',
            value: 'dmbtrdz',
            cellClass: 'linea-vertical-body',
            visible: true,
          },
          { text: 'DPP', align: 'center', value: 'difbudat', visible: false },
          {
            text: '% DPP',
            align: 'center',
            value: 'difbudatp',
            cellClass: 'linea-vertical-body',
            visible: false,
          },
          {
            text: 'Neto a Pagar',
            align: 'right',
            value: 'impfacnet',
            visible: true,
          },
        ],
      };
    },

    computed: {
      localSelected: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    methods: {
      getRowClass(item) {
        return item.status === 'VENCIDO' ? 'red-row' : '';
      },
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
